import React from 'react';
import axios from 'axios';
import { BarChart, XAxis, YAxis, Bar, Tooltip, LabelList } from 'recharts';
import { Form, Header, Segment, Loader } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl'; import { fetchFaculties, fetchAcademicYears, fetchStudyCycle, fetchGenderName } from '../Lookups/util';
import { center } from './util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class GraduatedPerStudyCycleAndGender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            faculties: [],
            faculty: '',
            academicYears: [],
            academicYear: '',
            data: [],
            genders: [],

            loading: true,
            showChart: false
        };

        this.fetchFacultiesAcademicYearsStudyCycleAndGender = this.fetchFacultiesAcademicYearsStudyCycleAndGender.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
        this.getStudyCycleName = this.getStudyCycleName.bind(this);
        this.getGenderName = this.getGenderName.bind(this);
        this.transformData = this.transformData.bind(this);
    }


    componentDidMount() {
        this.fetchFacultiesAcademicYearsStudyCycleAndGender();
    }

    getFacultyName() {
        const { faculties, faculty } = this.state;
        const selected = faculties.find(el => el.id === faculty);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }

    getGenderName(id) {
        const { genders } = this.state;
        const selected = genders.find(el => el.id === id);
        if (selected && selected._key) return selected._key;
        return '';
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    fetchFacultiesAcademicYearsStudyCycleAndGender() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchStudyCycle(), fetchGenderName()])
            .then(axios.spread((facultiesRes, academicYearsRes, studycyclesRes, gendersRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studycyclesRes.data.map(el => ({ ...el, value: el.id, name: el.name }));
                const genders = gendersRes.data.map(el => ({ ...el, value: el.id, name: el.name }));

                this.setState({
                    academicYears, faculties, studyCycles, genders, loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch faculties, academic years, study cycle or genders');
            });
    }

    transformData(data) {
        const data1 = data.reduce((acc, val) => {
            if (Object.prototype.hasOwnProperty.call(acc, val.studyCycle)) {
                acc[val.studyCycle] = { ...acc[val.studyCycle], [val.gender]: val.count };
                return acc;
            }
            acc[val.studyCycle] = { [val.gender]: val.count };
            return acc;
        }, {});

        return Object.keys(data1).map(key => ({ studyCycle: key, ...data1[key] }));
    }


    generateChartData() {
        const { faculty, academicYear } = this.state;
        axios.get(`/statistics/graduated-per-study-cycle-and-gender/?facultyId=${faculty}&academicYearId=${academicYear}`)
            .then(res => {
                const data = res.data.map(el => ({ ...el, studyCycle: this.getStudyCycleName(el.studyCycleId), gender: this.getGenderName(el.gender) }));
                const transformedData = this.transformData(data);
                this.setState({ data: transformedData, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }


    render() {
        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectFacultyAndAcademicYear" />}
                        </Header>
                    </Segment><Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.faculty" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectFaculty" />}
                                        value={this.state.faculty}
                                        onChange={this.handleInputChange}
                                        name="faculty"
                                        options={this.state.faculties}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.academicYear" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Button label=" " color="blue" basic="true" onClick={this.generateChartData}>{<FormattedMessage id="common.show" />}</Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                {this.state.showChart && <Segment.Group raised>
                    <Segment raised >
                        <Header as="h2">
                            {this.getFacultyName()}
                        </Header>
                        <Header as="h3">{<FormattedMessage id="statistics.headerNumberGraduatedStudentsPerStudyCycles" />} {this.getAcademicYearName()} {<FormattedMessage id="statistics.headerAcademicYear" />} </Header>

                    </Segment>
                    {data.length ? <Segment>
                        <br />

                        <BarChart
                            style={center}
                            width={930}
                            height={250}
                            data={data}
                            margin={{ top: 20 }}
                        >
                            <XAxis dataKey="studyCycle" />
                            <YAxis />
                            <Tooltip />

                            <Bar
                                dataKey="m"
                                fill="#bee3ed"
                                isAnimationActive
                            >
                                <LabelList dataKey="m" position="top" fill="#bee3ed" />
                            </Bar>
                            <Bar
                                dataKey="f"
                                fill="#ffc0cb"
                                isAnimationActive
                            >
                                <LabelList dataKey="f" position="top" fill="#ffc0cb" />
                            </Bar>
                        </BarChart>
                        <br />
                    </Segment>
                        : <Segment>
            Nema podataka na ovom fakultetu za odabranu akademsku godinu.
                        </Segment>}
                </Segment.Group>}
            </div>
        );
    }
}

export default GraduatedPerStudyCycleAndGender;



// WEBPACK FOOTER //
// ./src/views/Statistics/GraduatedPerStudyCycleAndGender.js